module.exports = __webpack_public_path__ + "static/b08e55633109ead6489bd2277ec2464193f35d2e0e1cc5b2c504664c39d47a56-39b8faad3a17528c498e6247e6818e58.png";